import React, { memo } from 'react';
import DataTable from 'react-data-table-component';

import Text from './Text';

interface TableProps {
  columns: any,
  data: any,
  title: string,
}

function Table({
  columns, data, title,
}: TableProps) {
  return (
    <div className="component-table">
      <DataTable columns={columns} data={data} title={<Text level="h3" textColor="highlight">{ title }</Text>} />
    </div>
  );
}

export default memo(Table);

Table.defaultProps = {
  columns: [],
  data: [],
  title: null,
};
